import { Spinner, View } from "tamagui";
import type { ViewProps } from "tamagui";

export const LoadingScreen: React.FC<ViewProps> = (props) => {
  return (
    <View justifyContent="center" alignItems="center" width={"100%"} {...props}>
      <Spinner color={"$green-500"} size={"large"} />
    </View>
  );
};
